import CART from '../constants/cart';

const { VOUCHER_REDEMPTION_TYPE, XO_PLUS_PLANS, SIM_ONLY_PLUS_PLAN } = CART;

// voucher redemption matrix
export const redemptionType = {
  25: {
    rules: [
      {
        redemptionType: VOUCHER_REDEMPTION_TYPE.REBATE,
        validations: {
          transactionType: { newSignup: true, recontract: false },
          withDevice: true,
          plansList: [SIM_ONLY_PLUS_PLAN]
        }
      },
      {
        redemptionType: VOUCHER_REDEMPTION_TYPE.NA,
        validations: {
          transactionType: { newSignup: false, recontract: true },
          withDevice: true,
          plansList: [SIM_ONLY_PLUS_PLAN]
        }
      },
      {
        redemptionType: VOUCHER_REDEMPTION_TYPE.NA,
        validations: {
          transactionType: { newSignup: true, recontract: true },
          withDevice: false,
          plansList: [SIM_ONLY_PLUS_PLAN]
        }
      }
    ],
    defaultRedemptionType: VOUCHER_REDEMPTION_TYPE.IMMEDIATE
  }
};

export default {
  redemptionType
};
